import { type FirebaseApp, initializeApp } from "firebase/app";
import { type Auth, getAuth } from "firebase/auth";
import { type Database, getDatabase } from "firebase/database";
import { loadEnv } from "../lib/env.js";

let app: FirebaseApp | undefined;
let auth: Auth | undefined;
let db: Database | undefined;

export function getFirebase(): { app: FirebaseApp; auth: Auth; db: Database } {
  if (!app) {
    const env = loadEnv();
    app = initializeApp({
      apiKey: env.firebase.apiKey,
      authDomain: env.firebase.authDomain,
      databaseURL: env.firebase.databaseURL,
      projectId: env.firebase.projectId,
      appId: env.firebase.appId,
    });
    auth = getAuth(app);
    db = getDatabase(app);
  }
  return { app: app as FirebaseApp, auth: auth as Auth, db: db as Database };
}
